import Vue from "vue"
import config from '@/config'

const socket = new WebSocket("wss://"+config.ws.host+':'+config.ws.port)

const emitter = new Vue({
    methods:{
        send(message){
            if (1 === socket.readyState)
                socket.send(message)
        }
    }
})

socket.onmessage = function(msg){
    emitter.$emit("message", JSON.parse(msg.data))
}
socket.onerror = function(err){
    emitter.$emit("error", err)
}


export default emitter
